import { TFunction } from "i18next"
import { Dispatch, SetStateAction } from "react"
import { ModeloImpuestoType } from "../../../../../api/Types/ModeloImpuesto"
import { MODELOS_IMPUESTOS } from "../constants/modelosImpuestos"

interface DetalleImpuestoTabNameProps {
  modelNumber: ModeloImpuestoType
  t: TFunction
  setModel: Dispatch<SetStateAction<ModeloImpuestoType>>
}
export const DetalleImpuestoTabName = ({
  modelNumber,
  t,
  setModel,
}: DetalleImpuestoTabNameProps) => {
  return (
    <div
      key='DetalleImpuesto'
      data-testid='detalle-impuesto-tab'
      onClick={() => setModel(modelNumber)}
    >
      <span>{t("taxSummary.tabTitle")}</span>
      <span className={MODELOS_IMPUESTOS()[modelNumber].className}>
        {modelNumber}
      </span>
    </div>
  )
}
